module.exports = __webpack_public_path__ + "static/media/chatgpt.e9837ea6.png";